export function getAvatarColor(stageGroupName?: string): string | undefined {
   switch (stageGroupName) {
      case 'Lead':
         return '#FF5733'
      case 'APT Set':
         return '#9F3C1C'
      case 'Forward Flow Stop Stage':
         return '#924C12'
      case 'FF Converting':
         return '#337bff'
      default:
         return '#337BFF'
   }
}


export function getStorageKey(stageFilter: string, campaignId: string | null) {
   const demoPrefix =
      window.location.pathname.includes('demo-conversations-old') ? 'demo_old_' :
         window.location.pathname.includes('demo-conversations') ? 'demo_' : ''
   
   const prefix = demoPrefix

   const stage = stageFilter === 'ff-appointment-set' ? 'apt-set' :
      stageFilter === 'ff-appointment-missed' ? 'apt-missed' : 'all-stages'

   const camp = campaignId || 'all-campaign'

   return `${prefix}ff_selected_lead_${stage}_${camp}`
}